module.exports = __webpack_public_path__ + "img/charge_online.3a107dd2.png";